import { actions } from './actions'

const initialState = {
  configuracionesCaso3Bis: {
    data: [],
    loading: false,
    error: '',
    reload: false,
  },
  configuracionesCaso3: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function configuracionesCaso3BisReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CONFIGURACIONES_CASO3_BIS_LOAD_REQUESTED:
      return {
        ...state,
        configuracionesCaso3Bis: { ...state.configuracionesCaso3Bis, loading: true },
      }
    case actions.CONFIGURACIONES_CASO3_BIS_LOAD_SUCCEEDED:
      return {
        ...state,
        configuracionesCaso3Bis: {
          ...state.configuracionesCaso3Bis,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.CONFIGURACIONES_CASO3_BIS_LOAD_FILED:
      return {
        ...state,
        configuracionesCaso3Bis: {
          ...state.configuracionesCaso3Bis,
          loading: false,
          error: action.error,
        },
      }

    case actions.CONFIGURACIONES_CASO3_LOAD_REQUESTED:
      return { ...state, configuracionesCaso3: { ...state.configuracionesCaso3, loading: true } }
    case actions.CONFIGURACIONES_CASO3_LOAD_SUCCEEDED:
      return {
        ...state,
        configuracionesCaso3: {
          ...state.configuracionesCaso3,
          data: action.payload,
          loading: false,
        },
      }
    case actions.CONFIGURACIONES_CASO3_LOAD_FILED:
      return {
        ...state,
        configuracionesCaso3: {
          ...state.configuracionesCaso3,
          loading: false,
          error: action.error,
        },
      }
    case actions.CONFIGURACION_CASO3_INSERT_REQUESTED:
      return {
        ...state,
        configuracionesCaso3: { ...state.configuracionesCaso3, loading: true, error: '' },
      }
    case actions.CONFIGURACION_CASO3_INSERT_SUCCEEDED:
      return {
        ...state,
        configuracionesCaso3: {
          ...state.configuracionesCaso3,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.CONFIGURACION_CASO3_INSERT_FILED:
      return {
        ...state,
        configuracionesCaso3: {
          ...state.configuracionesCaso3,
          loading: false,
          error: action.error,
        },
      }
    case actions.CONFIGURACION_CASO3_UPDATE_REQUESTED:
      return {
        ...state,
        configuracionesCaso3: { ...state.configuracionesCaso3, loading: true, error: '' },
      }
    case actions.CONFIGURACION_CASO3_UPDATE_SUCCEEDED:
      return {
        ...state,
        configuracionesCaso3: {
          ...state.configuracionesCaso3,
          data: action.payload,
          loading: false,
          error: '',
        },
      }
    case actions.CONFIGURACION_CASO3_UPDATE_FILED:
      return {
        ...state,
        configuracionesCaso3: {
          ...state.configuracionesCaso3,
          loading: false,
          error: action.error,
        },
      }
    case actions.CONFIGURACION_CASO3_BIS_DELETE_REQUESTED:
      return {
        ...state,
        configuracionesCaso3Bis: { ...state.configuracionesCaso3Bis, loading: true, error: '' },
      }
    case actions.CONFIGURACION_CASO3_BIS_DELETE_SUCCEEDED:
      return {
        ...state,
        configuracionesCaso3Bis: {
          ...state.configuracionesCaso3Bis,
          data: state.configuracionesCaso3Bis.data.filter(conf => conf.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.CONFIGURACION_CASO3_BIS_DELETE_FILED:
      return {
        ...state,
        configuracionesCaso3Bis: {
          ...state.configuracionesCaso3Bis,
          loading: false,
          error: action.error,
        },
      }
    case actions.CONFIGURACION_CASO3_BIS_UPDATE_REQUESTED:
      return {
        ...state,
        configuracionesCaso3Bis: { ...state.configuracionesCaso3Bis, loading: true, error: '' },
      }
    case actions.CONFIGURACION_CASO3_BIS_UPDATE_SUCCEEDED:
      return {
        ...state,
        configuracionesCaso3Bis: {
          ...state.configuracionesCaso3Bis,
          loading: false,
          error: '',
          reload: true,
        },
      }
    case actions.CONFIGURACION_CASO3_BIS_UPDATE_FILED:
      return {
        ...state,
        configuracionesCaso3Bis: {
          ...state.configuracionesCaso3Bis,
          loading: false,
          error: action.error,
        },
      }
    case actions.CONFIGURACION_CASO3_BIS_INSERT_REQUESTED:
      return {
        ...state,
        configuracionesCaso3Bis: { ...state.configuracionesCaso3Bis, loading: true, error: '' },
      }
    case actions.CONFIGURACION_CASO3_BIS_INSERT_SUCCEEDED:
      return {
        ...state,
        configuracionesCaso3Bis: {
          ...state.configuracionesCaso3Bis,
          loading: false,
          error: '',
          reload: true,
        },
      }
    case actions.CONFIGURACION_CASO3_BIS_INSERT_FILED:
      return {
        ...state,
        configuracionesCaso3Bis: {
          ...state.configuracionesCaso3,
          loading: false,
          error: action.error,
        },
      }
    default:
      return state
  }
}
